import { ConfigStore } from "../../stores";
export const isFormatMsgPack = (connectionName) => { var _a; return ((_a = ConfigStore.config.urls[connectionName]) === null || _a === void 0 ? void 0 : _a.format) === "msgpack"; };
//# sourceMappingURL=isFormatMsgPack.js.map